import PreviewProfile from './PreviewProfile';

export default PreviewProfile;
